export const oldBusStops = [
    {
        id: 1,
        name: 'Mońki–Dworcowa',
        Białystok: ['4:20', '5:15', '6:30', '7:25', '8:55', '10:05', '11:10', '12:20', '13:35', '14:40', '15:50', '17:05', '18:10', '19:20'],
        Mońki: ['6:17', '7:17', '8:37', '9:32', '10:57', '12:12', '13:22', '14:32', '15:42', '16:42', '17:52', '19:12', '20:12', '21:17'],
    },
    {
        id: 2,
        name: 'Mońki–Al.Wojs.Pol',
        Białystok: ['4:23', '5:18', '6:33', '7:28', '8:58', '10:08', '11:13', '12:23', '13:38', '14:43', '15:53', '17:08', '18:13', '19:23'],
        Mońki: ['6:15', '7:15', '8:35', '9:30', '10:55', '12:10', '13:20', '14:30', '15:40', '16:40', '17:50', '19:10', '20:10', '21:15'],
    },
    {
        id: 3,
        name: 'Mońki-Leśna',
        Białystok: ['4:25', '5:20', '6:35', '7:30', '9:00', '10:10', '11:15', '12:25', '13:40', '14:45', '15:55', '17:10', '18:15', '19:25'],
        Mońki: [ '6:12', '7:12', '8:32', '9:27', '10:52', '12:07', '13:17', '14:27', '15:37', '16:37', '17:47', '19:07', '20:07', '21:12' ],
    },
    {
        id: 4,
        name: 'Dziękonie',
        Białystok: [ '4:29', '5:24', '6:39', '7:34', '9:04', '10:14', '11:19', '12:29', '13:44', '14:49', '15:59', '17:14', '18:19', '19:29'],
        Mońki: [ '6:12', '7:12', '8:32', '9:27', '10:52', '12:07', '13:17', '14:27', '15:37', '16:37', '17:47', '19:07', '20:07', '21:12' ],
    },
    {
        id: 5,
        name: 'Czechowizna PKP',
        Białystok: ['4:31', '5:26', '6:41', '7:36', '9:06', '10:16', '11:21', '12:31', '13:46', '14:51', '16:01', '17:16', '18:21', '19:31'],
        Mońki: [ '6:06', '7:06', '8:26', '9:21', '10:46', '12:01', '13:11', '14:21', '15:31', '16:31', '17:41', '19:01', '20:01', '21:06' ],
    },
    {
        id: 6,
        name: 'Czechowizna Skrz.',
        Białystok: [ '4:33', '5:28', '6:43', '7:38', '9:08', '10:18', '11:23', '12:32', '13:48', '14:53', '16:03', '17:18', '18:23', '19:33'],
        Mońki: [ '6:04', '7:04', '8:24', '9:19', '10:44', '11:59', '13:09', '14:19', '15:29', '16:29', '17:39', '18:59', '19:59', '21:04' ],
    },
    {
        id: 7,
        name: 'Czechowizna',
        Białystok: ['4:34', '5:29', '6:44', '7:39', '9:09', '10:19', '11:24', '12:34', '13:49', '14:54', '16:04', '17:19', '18:24', '19:34'],
        Mońki: [ '6:03', '7:03', '8:23', '9:18', '10:43', '11:58', '13:08', '14:18', '15:28', '16:28', '17:38', '18:58', '19:58', '21:03' ],
    },
    {
        id: 8,
        name: 'Knyszyn-Gon.',
        Białystok: [ '4:38', '5:33', '6:48', '7:43', '9:13', '10:23', '11:28', '12:38', '13:53', '14:58', '16:08', '17:23', '18:28', '19:38'],
        Mońki: [ '5:59', '6:59', '8:19', '9:14', '10:39', '11:54', '13:04', '14:14', '15:24', '16:24', '17:34', '18:54', '19:54', '20:59' ],
    },
    {
        id: 9,
        name: 'Knyszyn-Rynek',
        Białystok: [ '4:39', '5:34', '6:49', '7:44', '9:14', '10:24', '11:29', '12:39', '13:54', '14:59', '16:09', '17:24', '18:29', '19:39'],
        Mońki: [ '5:58', '6:58', '8:18', '9:13', '10:38', '11:53', '13:03', '14:13', '15:23', '16:23', '17:33', '18:53', '19:53', '20:58' ],
    },
    {
        id: 10,
        name: 'Knyszyn Kolonia',
        Białystok: [ '4:43', '5:38', '6:53', '7:48', '9:18', '10:28', '11:33', '12:43', '13:58', '15:03', '16:13', '17:28', '18:33', '19:43'],
        Mońki: [ '5:54', '6:54', '8:14', '9:09', '10:34', '11:49', '12:59', '14:09', '15:19', '16:19', '17:29', '18:49', '19:49', '20:54' ],
    },
    {
        id: 11,
        name: 'Chraboły',
        Białystok: [ '4:45', '5:40', '6:55', '7:50', '9:20', '10:30', '11:35', '12:45', '14:00', '15:05', '16:15', '17:30', '18:35', '19:45'],
        Mońki: [ '5:51', '6:51', '8:11', '9:06', '10:31', '11:46', '12:56', '14:06', '15:16', '16:16', '17:26', '18:46', '19:46', '20:51' ],
    },
    {
        id: 12,
        name: 'Myśliwiec',
        Białystok: ['4:47', '5:42', '6:57', '7:52', '9:22', '10:32', '11:37', '12:47', '14:02', '15:07', '16:17', '17:32', '18:37', '19:47'],
        Mońki: [ '5:49', '6:49', '8:09', '9:04', '10:29', '11:44', '12:54', '14:04', '15:14', '16:14', '17:24', '18:44', '19:44', '20:49' ],
    },
    {
        id: 13,
        name: 'Kozińce',
        Białystok: [ '4:49', '5:44', '6:59', '7:54', '9:24', '10:34', '11:39', '12:49', '14:04', '15:09', '16:19', '17:34', '18:39', '19:49'],
        Mońki: [ '5:47', '6:47', '8:07', '9:02', '10:27', '11:42', '12:52', '14:02', '15:12', '16:12', '17:22', '18:42', '19:42', '20:47' ],
    },
    {
        id: 14,
        name: 'Obrubniki',
        Białystok: ['4:51', '5:46', '7:01', '7:56', '9:26', '10:36', '11:41', '12:51', '14:06', '15:11', '16:21', '17:36', '18:41', '19:51'],
        Mońki: [ '5:45', '6:45', '8:05', '9:00', '10:25', '11:40', '12:50', '14:00', '15:10', '16:10', '17:20', '18:40', '19:40', '20:45' ],
    },
    {
        id: 15,
        name: 'Krynice',
        Białystok: ['4:53', '5:48', '7:03', '7:58', '9:28', '10:38', '11:43', '12:53', '14:08', '15:13', '16:23', '17:38', '18:43', '19:53'],
        Mońki: [ '5:43', '6:43', '8:03', '8:58', '10:23', '11:38', '12:48', '13:58', '15:08', '16:08', '17:18', '18:38', '19:38', '20:43' ],
    },
    {
        id: 16,
        name: 'Gniła',
        Białystok: ['4:54', '5:49', '7:04', '7:59', '9:29', '10:39', '11:44', '12:54', '14:09', '15:14', '16:24', '17:39', '18:44', '19:54'],
        Mońki: [ '5:42', '6:42', '8:02', '8:57', '10:22', '11:37', '12:47', '13:57', '15:07', '16:07', '17:17', '18:37', '19:37', '20:42' ],
    },
    {
        id: 17,
        name: 'Dobrzyniewo D.',
        Białystok: ['4:56', '5:51', '7:06', '8:01', '9:31', '10:41', '11:46', '12:56', '14:11', '15:16', '16:26', '17:41', '18:46', '19:56'],
        Mońki: [ '5:40', '6:40', '8:00', '8:55', '10:20', '11:35', '12:45', '13:55', '15:05', '16:05', '17:15', '18:35', '19:35', '20:40' ],
    },
    {
        id: 18,
        name: 'Dzikie',
        Białystok: [ '4:59', '5:54', '7:09', '8:04', '9:34', '10:44', '11:49', '12:59', '14:14', '15:19', '16:29', '17:44', '18:49', '19:59'],
        Mońki: [ '5:37', '6:37', '7:57', '8:52', '10:17', '11:32', '12:42', '13:52', '15:02', '16:02', '17:12', '18:32', '19:32', '20:37' ],
    },
    {
        id: 19,
        name: 'Fasty',
        Białystok: ['5:01', '5:56', '7:11', '8:06', '9:36', '10:46', '11:51', '13:01', '14:16', '15:21', '16:31', '17:46', '18:51', '20:01'],
        Mońki: [ '5:35', '6:35', '7:55', '8:50', '10:15', '11:30', '12:40', '13:50', '15:00', '16:00', '17:10', '18:30', '19:30', '20:35' ],
    },
    {
        id: 20,
        name: 'Fasty Kombinat',
        Mońki: [ '5:33', '6:33', '7:53', '8:48', '10:13', '11:28', '12:38', '13:48', '14:58', '15:58', '17:08', '18:28', '19:28', '20:33' ],
    },
    {
        id: 21,
        name: 'Białystok–Cast.',
        Białystok: ['5:05', '6:00', '7:15', '8:10', '9:40', '10:50', '11:55', '13:05', '14:20', '15:25', '16:35', '17:50', '18:55', '20:05'],
        Mońki: [ '5:31', '6:31', '7:51', '8:46', '10:11', '11:26', '12:36', '13:46', '14:56', '15:56', '17:06', '18:26', '19:26', '20:31' ],
    },
    {
        id: 22,
        name: 'Bacieczki',
        Białystok: ['5:07', '6:02', '7:17', '8:12', '9:42', '10:52', '11:57', '13:07', '14:22', '15:27', '16:37', '17:52', '18:57', '20:07'],
        Mońki: [ '5:30', '6:30', '7:50', '8:45', '10:10', '11:25', '12:35', '13:45', '14:55', '15:55', '17:05', '18:25', '19:25', '20:30' ],
    },
    {
        id: 23,
        name: 'Białystok-J.Pawła',
        Białystok: ['5:10', '6:05', '7:20', '8:15', '9:45', '10:55', '12:00', '13:10', '14:25', '15:30', '16:40', '17:55', '19:00', '20:10'],
        Mońki: [ '5:27', '6:27', '7:47', '8:42', '10:07', '11:22', '12:32', '13:42', '14:52', '15:52', '17:02', '18:22', '19:22', '20:27' ],
    },
    {
        id: 24,
        name: 'Białystok PKP',
        Białystok: ['5:13', '6:08', '7:23', '8:18', '9:48', '10:58', '12:03', '13:13', '14:28', '15:33', '16:43', '17:58', '19:03', '20:13'],
    },
    {
        id: 25,
        name: 'Białystok PKS',
        Białystok: ['5:16', '6:11', '7:26', '8:21', '9:51', '11:01', '12:06', '13:16', '14:31', '15:36', '16:46', '18:01', '19:06', '20:16'],
        Mońki: [ '5:20', '6:20', '7:40', '8:35', '10:00', '11:15', '12:25', '13:35', '14:45', '15:45', '16:55', '18:15', '19:15', '20:20' ],
    }
];

export const busStops = [
  {
    id: 1,
    name: 'Mońki–Dworcowa',
    Białystok: ['4:20','5:15','6:35','7:25','8:55','10:00','11:10','12:20','13:30','14:35','15:50','17:10','18:10','19:20'],
    Mońki: ['6:17','7:17','8:37','9:37','10:57','12:12','13:22','14:27','15:42','16:47','17:52','19:12','20:12','21:17'],
  },
  {
    id: 2,
    name: 'Mońki–Al.Wojs.Pol',
    Białystok: ['4:23','5:18','6:38','7:28','8:58','10:03','11:13','12:23','13:33','14:38','15:53','17:13','18:13','19:23'],
    Mońki: ['6:15','7:15','8:35','9:35','10:55','12:10','13:20','14:25','15:40','16:45','17:50','19:10','20:10','21:15'],
  },
  {
    id: 3,
    name: 'Mońki-Leśna',
    Białystok: ['4:25','5:20','6:40','7:30','9:00','10:05','11:15','12:25','13:35','14:40','15:55','17:15','18:15','19:25'],
    Mońki: ['6:12','7:12','8:32','9:32','10:52','12:07','13:17','14:22','15:37','16:42','17:47','19:07','20:07','21:12'],
  },
  {
    id: 4,
    name: 'Dziękonie',
    Białystok: ['4:29','5:24','6:44','7:34','9:04','10:09','11:19','12:29','13:39','14:44','15:59','17:19','18:19','19:29'],
    Mońki: ['6:12','7:12','8:32','9:32','10:52','12:07','13:17','14:22','15:37','16:42','17:47','19:07','20:07','21:12'],
  },
  {
    id: 5,
    name: 'Czechowizna PKP',
    Białystok: ['4:31','5:26','6:46','7:36','9:06','10:11','11:21','12:31','13:41','14:46','16:01','17:21','18:21','19:31'],
    Mońki: ['6:06','7:06','8:26','9:26','10:46','12:01','13:11','14:16','15:31','16:36','17:41','19:01','20:01','21:06'],
  },
  {
    id: 6,
    name: 'Czechowizna Skrz.',
    Białystok: ['4:33','5:28','6:48','7:38','9:08','10:13','11:23','12:32','13:43','14:48','16:03','17:23','18:23','19:33'],
    Mońki: ['6:04','7:04','8:24','9:24','10:44','11:59','13:09','14:14','15:29','16:34','17:39','18:59','19:59','21:04'],
  },
  {
    id: 7,
    name: 'Czechowizna',
    Białystok: ['4:34','5:29','6:49','7:39','9:09','10:14','11:24','12:34','13:44','14:49','16:04','17:24','18:24','19:34'],
    Mońki: ['6:03','7:03','8:23','9:23','10:43','11:58','13:08','14:13','15:28','16:33','17:38','18:58','19:58','21:03'],
  },
  {
    id: 8,
    name: 'Knyszyn-Gon.',
    Białystok: ['4:38','5:33','6:53','7:43','9:13','10:18','11:28','12:38','13:48','14:53','16:08','17:28','18:28','19:38'],
    Mońki: ['5:59','6:59','8:19','9:19','10:39','11:54','13:04','14:09','15:24','16:29','17:34','18:54','19:54','20:59'],
  },
  {
    id: 9,
    name: 'Knyszyn-Rynek',
    Białystok: ['4:39','5:34','6:54','7:44','9:14','10:19','11:29','12:39','13:49','14:54','16:09','17:29','18:29','19:39'],
    Mońki: ['5:58','6:58','8:18','9:18','10:38','11:53','13:03','14:08','15:23','16:28','17:33','18:53','19:53','20:58'],
  },
  {
    id: 10,
    name: 'Knyszyn Kolonia',
    Białystok: ['4:43','5:38','6:58','7:48','9:18','10:23','11:33','12:43','13:53','14:58','16:13','17:33','18:33','19:43'],
    Mońki: ['5:54','6:54','8:14','9:14','10:34','11:49','12:59','14:04','15:19','16:24','17:29','18:49','19:49','20:54'],
  },
  {
    id: 11,
    name: 'Chraboły',
    Białystok: ['4:45','5:40','7:00','7:50','9:20','10:25','11:35','12:45','13:55','15:00','16:15','17:35','18:35','19:45'],
    Mońki: ['5:51','6:51','8:11','9:11','10:31','11:46','12:56','14:01','15:16','16:21','17:26','18:46','19:46','20:51'],
  },
  {
    id: 12,
    name: 'Myśliwiec',
    Białystok: ['4:47','5:42','7:02','7:52','9:22','10:27','11:37','12:47','13:57','15:02','16:17','17:37','18:37','19:47'],
    Mońki: ['5:49','6:49','8:09','9:09','10:29','11:44','12:54','13:59','15:14','16:19','17:24','18:44','19:44','20:49'],
  },
  {
    id: 13,
    name: 'Kozińce',
    Białystok: ['4:49','5:44','7:04','7:54','9:24','10:29','11:39','12:49','13:59','15:04','16:19','17:39','18:39','19:49'],
    Mońki: ['5:47','6:47','8:07','9:07','10:27','11:42','12:52','13:57','15:12','16:17','17:22','18:42','19:42','20:47'],
  },
  {
    id: 14,
    name: 'Obrubniki',
    Białystok: ['4:51','5:46','7:06','7:56','9:26','10:31','11:41','12:51','14:01','15:06','16:21','17:41','18:41','19:51'],
    Mońki: ['5:45','6:45','8:05','9:05','10:25','11:40','12:50','13:55','15:10','16:15','17:20','18:40','19:40','20:45'],
  },
  {
    id: 15,
    name: 'Krynice',
    Białystok: ['4:53','5:48','7:08','7:58','9:28','10:33','11:43','12:53','14:03','15:08','16:23','17:43','18:43','19:53'],
    Mońki: ['5:43','6:43','8:03','9:03','10:23','11:38','12:48','13:53','15:08','16:13','17:18','18:38','19:38','20:43'],
  },
  {
    id: 16,
    name: 'Gniła',
    Białystok: ['4:54','5:49','7:09','7:59','9:29','10:34','11:44','12:54','14:04','15:09','16:24','17:44','18:44','19:54'],
    Mońki: ['5:42','6:42','8:02','9:02','10:22','11:37','12:47','13:52','15:07','16:12','17:17','18:37','19:37','20:42'],
  },
  {
    id: 17,
    name: 'Dobrzyniewo D.',
    Białystok: ['4:56','5:51','7:11','8:01','9:31','10:36','11:46','12:56','14:06','15:11','16:26','17:46','18:46','19:56'],
    Mońki: ['5:40','6:40','8:00','9:00','10:20','11:35','12:45','13:50','15:05','16:10','17:15','18:35','19:35','20:40'],
  },
  {
    id: 18,
    name: 'Dzikie',
    Białystok: ['4:59','5:54','7:14','8:04','9:34','10:39','11:49','12:59','14:09','15:14','16:29','17:49','18:49','19:59'],
    Mońki: ['5:37','6:37','7:57','8:57','10:17','11:32','12:42','13:47','15:02','16:07','17:12','18:32','19:32','20:37'],
  },
  {
    id: 19,
    name: 'Fasty',
    Białystok: ['5:01','5:56','7:16','8:06','9:36','10:41','11:51','13:01','14:11','15:16','16:31','17:51','18:51','20:01'],
    Mońki: ['5:35','6:35','7:55','8:55','10:15','11:30','12:40','13:45','15:00','16:05','17:10','18:30','19:30','20:35'],
  },
  {
    id: 20,
    name: 'Fasty Kombinat',
    Mońki: ['5:33','6:33','7:53','8:53','10:13','11:28','12:38','13:43','14:58','16:03','17:08','18:28','19:28','20:33'],
  },
  {
    id: 21,
    name: 'Białystok–Cast.',
    Białystok: ['5:05','6:00','7:20','8:10','9:40','10:45','11:55','13:05','14:15','15:20','16:35','17:55','18:55','20:05'],
    Mońki: ['5:31','6:31','7:51','8:51','10:11','11:26','12:36','13:41','14:56','16:01','17:06','18:26','19:26','20:31'],
  },
  {
    id: 22,
    name: 'Bacieczki',
    Białystok: ['5:07','6:02','7:22','8:12','9:42','10:47','11:57','13:07','14:17','15:22','16:37','17:57','18:57','20:07'],
    Mońki: ['5:30','6:30','7:50','8:50','10:10','11:25','12:35','13:40','14:55','16:00','17:05','18:25','19:25','20:30'],
  },
  {
    id: 23,
    name: 'Białystok-J.Pawła',
    Białystok: ['5:10','6:05','7:25','8:15','9:45','10:50','12:00','13:10','14:20','15:25','16:40','18:00','19:00','20:10'],
    Mońki: ['5:27','6:27','7:47','8:47','10:07','11:22','12:32','13:37','14:52','15:57','17:02','18:22','19:22','20:27'],
  },
  {
    id: 24,
    name: 'Białystok PKP',
    Białystok: ['5:13','6:08','7:28','8:18','9:48','10:53','12:03','13:13','14:23','15:28','16:43','18:03','19:03','20:13'],
  },
  {
    id: 25,
    name: 'Białystok PKS',
    Białystok: ['5:16','6:11','7:31','8:21','9:51','10:56','12:06','13:16','14:26','15:31','16:46','18:06','19:06','20:16'],
    Mońki: ['5:20','6:20','7:40','8:40','10:00','11:15','12:25','13:30','14:45','15:50','16:55','18:15','19:15','20:20'],
  }
];

